const postServices = {
  toastr: 'Added service',
  toastrError: 'Service already registered',
  toastrError1: 'Registered name'
};

export default postServices;
